import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import SupportTickets from './SupportTickets';

function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }
  return {
    title: 'Support Tickets | Admin',
    component: (
      <AdminLayout>
        <SupportTickets />
      </AdminLayout>
    ),
  };
}

export default action;
